// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconEmail: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M1.125 2A1.14 1.14 0 000 3.125c0 .352.164.68.445.89L5.32 7.673c.399.305.961.305 1.36 0l4.875-3.656c.28-.211.445-.54.445-.891C12 2.515 11.508 2 10.875 2h-9.75zM0 5.094V9.5c0 .82.68 1.5 1.5 1.5h9c.82 0 1.5-.68 1.5-1.5V5.094L7.36 8.586a2.322 2.322 0 01-2.72 0L0 5.094z" />
        </svg>
    );
};

export default React.memo(IconEmail);
